import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DefaultDatePipe } from '../../../../shared/_pipes/default-date.pipe';
import { SafeHtmlPipe } from '../../../../shared/_pipes/safe-html.pipe';

@Component({
  selector: 'app-event-preview-modal',
  templateUrl: './event-preview-modal.component.html',
  styleUrls: ['./event-preview-modal.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, DefaultDatePipe, SafeHtmlPipe],
})
export class EventPreviewModalComponent implements OnInit {
  name?: string;
  description?: string;
  image?: string;
  startDate?: Date;
  endDate?: Date;
  withTime: boolean = true;
  isOneDay = false;
  constructor(public bsModalRef: BsModalRef) {}

  ngOnInit() {
    if (
      new Date(this.startDate!).getHours() === new Date(this.endDate!).getHours() &&
      new Date(this.startDate!).getMinutes() === new Date(this.endDate!).getMinutes()
    ) {
      this.withTime = false;
    }
    if (new Date(this.startDate!).getDay() === new Date(this.endDate!).getDay()) {
      this.isOneDay = true;
    }
  }

  decline(): void {
    this.bsModalRef?.hide();
  }
}
